module.exports = __webpack_public_path__ + "img/boxman.034be151.png";